import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const Spread: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('spread');

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748934050741/Break%20PV%20Installation%20Limits_01.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748934050741/Break%20PV%20Installation%20Limits_01.jpg',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748934050981/Break%20PV%20Installation%20Limits_02.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748934050981/Break%20PV%20Installation%20Limits_02.jpg',
        },
    ];
    return (
        <div className={styles.Spread}>
            <EcoSectionCommon desc={t('desc')} label={t('label')} title={t('title')} />
            <div className="box">
                {items.map((item) => {
                    return (
                        <div className="wrapper" key={item.title}>
                            <EcoImg pc={item.pc} pad={item.pad} />
                            <div className="title">{item.title}</div>
                            <div className="desc">{item.desc}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Spread;
